'use strict';

var _arguments = arguments;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var React = require('react');
var _ = require('lodash');
var displayNames = require('../controls/displayNames');

var wrapOption = function wrapOption(compClass, extraProps, opt) {

    var isValidElement = React.isValidElement(opt);
    var shouldNotWrap = isValidElement && _.isUndefined(opt.props.value);
    var isStickyFooter = isValidElement && _.get(opt, 'type.getDisplayName', _.noop)() === displayNames.DROP_DOWN_STICKY_FOOTER;

    if (isStickyFooter) {
        return React.cloneElement(opt, {
            registerStickyFooter: extraProps.registerStickyFooter,
            key: 'stickyFooter'
        });
    }

    if (shouldNotWrap) {
        return opt;
    }

    var isStringValue = _.isString(opt);

    var _ref = isValidElement ? {
        val: opt.props.value,
        disabled: opt.props.disabled,
        children: opt,
        automationId: opt.props.automationId || null
    } : {
        val: isStringValue ? opt : opt.value,
        children: isStringValue ? opt : opt.label || opt.val,
        disabled: isStringValue ? false : opt.disabled,
        automationId: isStringValue ? null : opt.automationId || null
    },
        val = _ref.val,
        children = _ref.children,
        disabled = _ref.disabled,
        automationId = _ref.automationId;

    var props = _.assign({}, {
        disabled: disabled,
        value: val,
        key: val,
        automationId: automationId
    }, _.omit(extraProps, ['registerStickyFooter']));

    return React.createElement(compClass, props, children);
};

var optionType = React.PropTypes.oneOfType([React.PropTypes.string.isRequired, React.PropTypes.element.isRequired, React.PropTypes.object.isRequired]);
var optionsValidator = React.PropTypes.arrayOf(optionType).isRequired;

var getPropType = function getPropType(prop) {
    return _.get(prop, 'constructor.name', typeof prop === 'undefined' ? 'undefined' : _typeof(prop));
};

var validateOptionsOrChildren = function validateOptionsOrChildren(props, propName, componentName) {
    if (!(!props.options ^ !props.children)) {
        return new Error(componentName + ' must have either options or children but not both.');
    }
    if (props[propName] && !optionsValidator.apply(undefined, _arguments)) {
        return new Error('Invalid prop `' + propName + '` of type `' + getPropType(props[propName]) + '` supplied to `' + componentName + '`, expected `array` of either `string` or `object` or `element`.');
    }
};

module.exports = {
    wrapOption: wrapOption,
    PropTypes: {
        options: validateOptionsOrChildren
    }
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/util/dropDownHelpers.js